<template>
  <div class="view">
    <Title title="ホーム"/>
    <HomeMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import HomeMain from '@/components/HomeMain.vue'

export default {
  components: {
    Title,
    HomeMain
  }
}
</script>
